// extracted by mini-css-extract-plugin
module.exports = {"actions":"serviceType-actions_actions__3A5ir"};